import { Component, ChangeDetectionStrategy } from '@angular/core';
import { enterComponent } from '../animations';

import { OnlineMenuNavTypesComponent } from '../online-menu-nav-types.shared.component';

@Component({
    selector: 'shared-online-menu-nav-for-desktop',
    templateUrl: './online-menu-nav-for-desktop.shared.component.html',
    styleUrls: ['./online-menu-nav-for-desktop.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        enterComponent()
    ]
})
export class OnlineMenuNavForDesktopComponent extends OnlineMenuNavTypesComponent {
}
